import React, { useEffect, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Knoppie from './Knoppie';
import SearchBar from './SearchBar';
import ButtonGrid from './ButtonGrid';
import List from './List';
import Thumb from './Thumb';
import NoImage from '../images/no-image.png';
import useAuth from '../hooks/useAuth';
import { useAdditionsListFetch } from '../hooks/useAdditionsListFetch';

const AdditionsList = () => {
  const auth = useAuth();
  const location = useLocation();
  const from = location.state?.from || "./";
  const { additionstate, additionloading, additionerror,additionsearchValue, additionsetSearchValue, additionsetIncludeInactive, fetchAdditionsList } = useAdditionsListFetch();
  const observer = useRef();

  console.log(additionstate)
  const lastStockItemRef = useCallback(
    
    
    (node) => {
      console.log("total pages = "+additionstate.total_pages +" and page is " + additionstate.page)
      if (additionloading || additionstate.additions.length >= additionstate.total_results) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          fetchAdditionsList(additionstate.page,additionsearchValue);
        }
      });
      if (node) observer.current.observe(node);
    },
    [additionloading, fetchAdditionsList, additionstate.page]
  );

  const username = auth.auth.user.username;
  const access = auth.auth.user.userRole;

  return (
    <>
      <Header username={username} role={access} destination={from} />

      {access === "administrator" && (
        <Knoppie destination={`/addNewStockitem`} text={'Add new Addition'} clickable={true} from={'../AdditionsList'} />
      )}

      <div className='ListHead'>
        <SearchBar key={1} setSearchValue={additionsetSearchValue} />
        <div>Stock Items {additionstate.additions.length}/{additionstate.total_results}</div>
        <ButtonGrid>
          <Knoppie
            text={'Show All'}
            clickable={true}
            dropdown={true}
            switchOn={true}
            callback={() => additionsetIncludeInactive(true)}
          />
          <Knoppie
            text={'Show Active Only'}
            clickable={true}
            dropdown={true}
            switchOn={false}
            callback={() => additionsetIncludeInactive(false)}
          />
          

        </ButtonGrid>
      </div>

      {additionerror && <div>Error loading stock items</div>}

      <List  destination={''}>
        <div className='AdditionListLine'>
        <div>code</div>
        <div>Description</div>
        <div>type</div>
        <div>apply</div>
        <div>calcuif</div>
        <div>irpcode</div>
        <div>glcode</div>
        <div>Actions</div>
        </div>
        {additionstate.additions.length > 0 ? (
          additionstate.additions.map((item, index) => (
            <div className='AdditionListLine' key={item._id} ref={index === additionstate.additions.length - 1 ? lastStockItemRef : null}>
              
              <div>{item.code}</div>
              <div>{item.description}</div>
              <div>{item.type}</div>
              <div>{item.apply}</div>
              <div>{item.calcuif}</div>
              <div>{item.irpcode}</div>
              <div>{item.glcode}</div>
             

              {access === "administrator" && (
                <Knoppie text={"Delete"} clickable={true} callback={() => console.log("Delete", item._id)} />
              )}
              
              
         
            </div>
          ))
        ) : (
          <div>No Additions found.</div>
        )}
      </List>

      {additionloading && <h1>Loading more items...</h1>}
    </>
  );
};

export default AdditionsList;
